import React, { ReactNode } from 'react';

export type BenefitType = {
	title: ReactNode;
	titleModal: ReactNode;
	text: string;
	textMobile: string;
	modalText: string;
	bgSrc: string;
	bgSrcMobile: string;
	gaTitle: string;
};

export const benefitsDb: BenefitType[] = [
	{
		gaTitle: 'Вернём деньги за замер и осмечивание',
		title: (
			<div>
				Вернём&nbsp;деньги за&nbsp;замер <br /> и&nbsp;осмечивание
			</div>
		),
		titleModal: (
			<div>
				Вернём&nbsp;деньги за&nbsp;замер <br /> и&nbsp;осмечивание
			</div>
		),
		text: 'Сделаем точный замер помещения, а на 3-й день подготовим смету',
		textMobile: 'Сделаем точный замер помещения',
		modalText:
			'Сделаем точный замер помещения, а на 3-й день подготовим смету — компенсируем средства за обе услуги',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750838352/fudzi/services-platform/landing-small-2.png/landing-small-2.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750840802/fudzi/services-platform/landing-small-2-mobile.png/landing-small-2-mobile.png',
	},
	{
		gaTitle: 'Позаботимся о всех этапах',
		title: (
			<>
				Позаботимся
				<br /> о всех этапах
			</>
		),
		titleModal: <>Позаботимся о всех этапах</>,
		text: 'Подберём все необходимые товары и услуги, оформим доставку',
		textMobile: 'Подберём все необходимые товары и услуги',
		modalText:
			'Подберём все необходимые товары и услуги, оформим доставку и будем рядом на всех этапах ремонта',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750840802/fudzi/services-platform/landing-small-1.png/landing-small-1.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750840802/fudzi/services-platform/landing-small-1-mobile.png/landing-small-1-mobile.png',
	},
	{
		gaTitle: 'Предоставим надёжных мастеров',
		title: (
			<div>
				Предоставим надёжных <br />
				мастеров
			</div>
		),
		titleModal: (
			<div>
				Предоставим надёжных <br />
				мастеров
			</div>
		),
		text: 'Мы работаем только с проверенными партнёрами',
		textMobile: 'Проверенные партнёры',
		modalText:
			'Мы работаем только с проверенными партнёрами, где каждый мастер — профессионал своего дела',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750838352/fudzi/services-platform/landing-small-4.png/landing-small-4.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750838352/fudzi/services-platform/landing-small-4-mobile.png/landing-small-4-mobile.png',
	},
	{
		gaTitle: 'Гарантируем качество',
		title: (
			<div>
				Гарантируем <br /> качество
			</div>
		),
		titleModal: <div>Гарантируем качество</div>,
		text: 'Предоставим годовую гарантию на услуги',
		textMobile: 'Предоставим годовую гарантию на услуги',
		modalText:
			'Предоставим годовую гарантию на услуги. А ещё возможность вернуть любой товар в течение 100 дней, а с Сервисной картой — в течение 1 года',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750838352/fudzi/services-platform/landing-small-3.png/landing-small-3.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1750838352/fudzi/services-platform/landing-small-3-mobile.png/landing-small-3-mobile.png',
	},
];
